module.exports = __webpack_public_path__ + "src/assets/images/agreement.bd6c00cad4e9bba15950a0ce9554c50f.png";